import $ from 'jquery';

import 'normalize.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/assets/css/style.scss';

$(() => {
  $('.nav-open').on('click', () => {
    $('.nav-dropdown').addClass('open');
  });

  $('.nav-close').on('click', () => {
    $('.nav-dropdown').removeClass('open');
  });

  $('.accordions .accordion .title').on('click', (e) => {
    $('.accordion .text').slideUp();
    $('.accordion').removeClass('open');
    $(e.target).parent().addClass('open');
    $(e.target).siblings('.text').slideDown();
  });

  /* $('.hover-accordions .accordion .title').on('click', (e) => {
    if (window.innerWidth < 980) {
      $('.accordion .text').slideUp();
      $('.accordion').removeClass('open');
      $(e.target).parent().addClass('open');
      $(e.target).siblings('.text').slideDown();
    }
  });

  $('.hover-accordions .accordion .title').on('mouseenter', (e) => {
    if (window.innerWidth >= 980) {
      $('.accordion').removeClass('open');
      $(e.target).parent().addClass('open');
      $('.hover-text').slideUp();
      setTimeout(() => {
        $('.hover-text').text($(e.target).siblings('.text').text());
        $('.hover-text').slideDown();
      }, 450);
    }
  }); */

  let pageNumber = 1;

  function load_posts() {
    pageNumber++;
    const str = `&pageNumber=${pageNumber}&action=more_post_ajax`;
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: ajax.url,
      data: str,
      success(data) {
        const $data = $(data);
        if ($data.length) {
          $('.posts').append($data);

          if ($data.length < 3) {
            $('.more-posts').hide();
            $('.posts').append('<h3 class="col col-md-12">There are no older posts.</h3>');
          }
        }
        else {
          $('.more-posts').hide();
          $('.posts').append('<h3 class="col col-md-12">There are no older posts.</h3>');
        }
      },
      error(jqXHR, textStatus, errorThrown) {
        $loader.html(`${jqXHR} :: ${textStatus} :: ${errorThrown}`);
      }

    });
    return false;
  }

  $('.more-posts').on('click', () => {
    load_posts();
  });

  $(document).on('scroll', function () {
    if ($(this).scrollTop() > 0) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  });

  const menuContainer = $('.menu-header-container');
  if (menuContainer.length > 0) {
    const lastListItem = menuContainer.find('ul > li:last-child');
    if (lastListItem.length > 0) {
      const anchorLink = lastListItem.find('a');
      if (anchorLink.length > 0) {
        anchorLink.attr('target', '_blank');
      }
    }
  }
});
